import {Component, computed, effect, EventEmitter, Output, Signal} from '@angular/core';
import {
  DisplayedColumns,
  IApiTableData,
  TableControlComponent,
  TableControlModule,
  TableRowSelectionComponent,
} from 'frontier/browserkit';
import AppControlGuids from "../../../../api/ControlGuids";
import {ConditionTableNewProfileRequest, TProfile} from "../../../../api/generated";
import {IControlObject} from "frontier";
import {EConditionAttributes} from "../../testrules-query-builder/testrules-query-builder-enums-and-interfaces";

export interface IProfile extends ConditionTableNewProfileRequest {
  inuse: boolean;
  guid: string;
  controlObj: IControlObject;
}

interface IColumnsInfo {
  profileRepo: TProfile[];
  applicationIndex: number;
  activeIndex: number;
  descriptionIndex: number;
  guidIndex: number;
}

@Component({
  selector: 'app-condition-table',
  templateUrl: '../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.html',
  styleUrl: '../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.scss',
  standalone: true,
  imports: [TableControlModule],
  providers: [{provide: TableControlComponent, useExisting: ConditionTableComponent}],
})

export class ConditionTableComponent extends TableRowSelectionComponent {
  override GUID: string = AppControlGuids.TConditionTable;
  override tableName: string = 'Prüfregeln';

  readonly columnsInfo: Signal<IColumnsInfo> = computed((): IColumnsInfo => {
    const data: IApiTableData = this.apiData();
    if (!data) {
      return {
        profileRepo: null,
        applicationIndex: -1,
        activeIndex: -1,
        descriptionIndex: -1,
        guidIndex: -1,
      };
    }
    const columns: DisplayedColumns[] = data.displayedColumns;
    const profileRepo = columns.find(
      (col: DisplayedColumns): boolean => col.attribute === 'profile')?.repository as TProfile[];
    return {
      profileRepo,
      applicationIndex: columns.findIndex((col: DisplayedColumns): boolean => col.attribute === EConditionAttributes.application),
      activeIndex: columns.findIndex((col: DisplayedColumns): boolean => col.attribute === EConditionAttributes.active),
      descriptionIndex: columns.findIndex((col: DisplayedColumns): boolean => col.attribute === EConditionAttributes.description),
      guidIndex: columns.findIndex((col: DisplayedColumns): boolean => col.attribute === EConditionAttributes.guid),
    };
  });

  @Output() repoChanged: EventEmitter<TProfile[]> = new EventEmitter<TProfile[]>();

  constructor() {
    super();
    effect((): void => {
      const info: IColumnsInfo = this.columnsInfo();
      this.repoChanged.emit(info.profileRepo);
    });
  }
}
